import "./App.css";
import AppRoutes from "routes/AppRoutes";
import { AuthProvider, useAuth } from "../src/contexts/AuthContext";
import React, { useEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import ErrorBoundary from "components/ErrorBoundary";
import { GlobalLoaderProvider } from "../src/contexts/GlobalLoaderContext";
import { GlobalLoader } from "../src/components/GlobalLoader";
import Toast from "components/Toast";
import { useStore } from "store/zustand";
import { useToastStore } from "store/toastStore";
import { onMessage } from "firebase/messaging";
import { auth, messaging, requestPermissionAndSaveToken } from "config/firebaseConfig";

function App() {
  const { isAuthenticated } = useStore();

  
  React.useEffect(() => {
    if (isAuthenticated) {
      requestPermissionAndSaveToken();
    }
  }, [isAuthenticated]);

  const { showToast } = useToastStore(); // If your toast logic is in the same store

  useEffect(() => {
    if (!messaging) return;
    const unsubscribe = onMessage(messaging, (payload: any) => {
      showToast(payload?.notification?.body, "success", 5000);
    });
    return () => unsubscribe();
  }, [showToast]);
  
  return (
    <GlobalLoaderProvider>
      <Router>
        <ErrorBoundary>
          <GlobalLoader />
          <AppRoutes />
          <Toast />
        </ErrorBoundary>
      </Router>
    </GlobalLoaderProvider>
  );
}

export default App;
